import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import RHService from '../../../../../services/rh-auth';
import Estagiario from './estagiario';


const ListarEstagiario = () => {

    const [estagiarios, setEstagiarios] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [secretarias, setSecretarias] = useState([]);
    const [est, setEst] = useState("");


    async function fetchEstagiarios() {
        await montaSelectSecretarias()
        const response = await RHService.listarEstagiarios();
        if (response.data.length >= 1) {
            setEstagiarios(response.data)
            setVazio(false)
        } else {
            setEstagiarios([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setEst(id);
        setEditar(true)
    }

    const montaSelectSecretarias = async () => {
        const prod = await RHService.listarEstagiarios();
        setSecretarias(prod.data)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o Estagiário?')) {
            await RHService.deletarEstagiario(id)
            alert("Estagiário deletado com sucesso!")
            fetchEstagiarios();
        }
    }

    useEffect(() => {
        fetchEstagiarios();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/rh/estagiario/editar/${est}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setEstagiarios={setEstagiarios}
                        setVazio={setVazio}
                        secretarias={secretarias}
                        fetchEstagiarios={fetchEstagiarios}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={3}>
                            {estagiarios.map((est, index) =>
                                <Estagiario
                                    fetchEstagiarios={fetchEstagiarios}
                                    est={est}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarEstagiario;